import { ReactNode } from 'react';
import { List } from '@chakra-ui/react';

const sectionItemListStyle = (isSubsection?: boolean) => ({
  rowGap: isSubsection ? '0' : 'padding_8',
  paddingBottom: isSubsection ? 'padding_4' : '0',
  display: 'flex',
  flexDirection: 'column',
});

type TSectionItemListProps = {
  isSubsection?: boolean;
  children: ReactNode;
};

const SectionItemList = ({ isSubsection, children }: TSectionItemListProps) => {
  return <List sx={sectionItemListStyle(isSubsection)}>{children}</List>;
};

export default SectionItemList;
